import { createContext, useContext } from 'react'

import { ToastAnchor } from './config'
import { VisibleToast } from './types'

/**
 * Kept separate from ToastContext so that adding a toast doesn't re-render
 * every consumer of `addToast` — which is the entire app.
 */
export const ToastListContext = createContext<{
  visible: VisibleToast[]
  dismiss: (id: number) => void
  anchor: ToastAnchor
}>({
  visible: [],
  dismiss: () => {},
  anchor: 'top-center'
})

export const useToastList = () => useContext(ToastListContext)
